import React, { useCallback, useEffect, useState } from "react";
import { StyledMyInfoDialog } from "./StyledMyInfoDialog";
import { UserInfoType } from "../../../../../types/common/userTypes";
import { getMyInfo } from "../../../../../api/userApi";
import BadgeIcon from "@mui/icons-material/Badge";
import PersonIcon from "@mui/icons-material/Person";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import Groups2Icon from "@mui/icons-material/Groups2";
import { Chip } from "@mui/material";

const MY_INFO_KEY: (keyof UserInfoType)[] = [
  "loginId",
  "username",
  "groupName",
  "mobile",
  "email",
];

const MyInfoDialog = () => {
  const [myInfo, setMyInfo] = useState<UserInfoType | null>(null);

  const fetchMyInfo = async () => {
    const result = await getMyInfo();

    if (result.isSuccess) {
      setMyInfo(result);
    }
  };

  const returnIcon = useCallback((key: keyof UserInfoType) => {
    switch (key) {
      case "loginId":
        return (
          <Chip className="myinfo-chip" icon={<BadgeIcon />} label="아이디" />
        );
      case "username":
        return (
          <Chip className="myinfo-chip" icon={<PersonIcon />} label="사용자" />
        );
      case "mobile":
        return (
          <Chip
            className="myinfo-chip"
            icon={<PhoneAndroidIcon />}
            label="전화번호"
          />
        );
      case "email":
        return (
          <Chip
            className="myinfo-chip"
            icon={<AlternateEmailIcon />}
            label="이메일"
          />
        );
      case "groupName":
        return (
          <Chip className="myinfo-chip" icon={<Groups2Icon />} label="그룹명" />
        );
      default:
        return null;
    }
  }, []);

  useEffect(() => {
    fetchMyInfo();
  }, []);

  return (
    <StyledMyInfoDialog>
      <div>
        {MY_INFO_KEY.map((key) => (
          <div key={key} className="my-info-row">
            {returnIcon(key)}
            <p>{myInfo ? myInfo[key] : "-"}</p>
          </div>
        ))}
      </div>
    </StyledMyInfoDialog>
  );
};

export default MyInfoDialog;
